import { render, staticRenderFns } from "./project-settings-general-settings.vue?vue&type=template&id=6c7d7a24&"
import script from "./project-settings-general-settings.vue?vue&type=script&lang=ts&"
export * from "./project-settings-general-settings.vue?vue&type=script&lang=ts&"
import style0 from "./project-settings-general-settings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports